/**
 * External dependencies
 */
import { combineReducers } from 'redux';
/**
 * Internal dependencies
 */

import { createReducer } from 'state/utils';
import {
    CURRENT_VISUALDECK_RECEIVE,
    CURRENT_VISUALDECK_REQUEST,
    CURRENT_VISUALDECK_REQUEST_SUCCESS,
    CURRENT_VISUALDECK_REQUEST_FAILURE,
} from 'state/action-types';

export const requesting = createReducer(false, {
    [CURRENT_VISUALDECK_REQUEST]: () => true,
    [CURRENT_VISUALDECK_REQUEST_SUCCESS]: () => false,
    [CURRENT_VISUALDECK_REQUEST_FAILURE]: () => false,
});

const items = createReducer(null, {
    [CURRENT_VISUALDECK_RECEIVE]: (state, action) => action.payload.visualdeck,
});

export const error = createReducer(false, {
    [CURRENT_VISUALDECK_REQUEST]: () => false,
    [CURRENT_VISUALDECK_REQUEST_SUCCESS]: () => false,
    [CURRENT_VISUALDECK_REQUEST_FAILURE]: () => true,
});

export default combineReducers({
    items,
    requesting,
    error
});
